import sendNetworkReq from '@/utils/sendNetworkReq';

export const LOADING_MESSAGES = 'LOADING_MESSAGES';
export const GET_ALL_MESSAGES = 'GET_ALL_MESSAGES';
export const SEARCH_MESSAGES = 'SEARCH_MESSAGES';

export const getAllMessages = () => {
	return async (dispatch) => {
		const response = await sendNetworkReq({
			method: 'GET',
			url: 'messages/all',
			auth: false,
		});
		dispatch({
			type: GET_ALL_MESSAGES,
			payload: response?.messages || [],
		});
	};
};

export const searchMessages = (query) => {
	return async (dispatch) => {
		dispatch({
			type: LOADING_MESSAGES,
			payload: true,
		});
		const { messages } = await sendNetworkReq({
			method: 'GET',
			url: `messages/search?query=${query}`,
			auth: false,
		});
		dispatch({
			type: SEARCH_MESSAGES,
			payload: messages || [],
		});
		dispatch({
			type: LOADING_MESSAGES,
			payload: false,
		});
	};
};
